import React from 'react';
import Button, { buttonVariants } from '@weave-mui/button';
import StandardEmptyState from '../../components/StandardEmptyState';

/**
 * Empty state component displayed when there are no projects
 * @param {Object} props - Component props
 * @param {Function} props.onCreateProject - Callback function when Create Project button is clicked
 */
const EmptyProjectsState = ({ onCreateProject }) => {
  return (
    <StandardEmptyState
      headline="No projects yet"
      tagline="To get started, create a project"
      callToAction={
        <Button variant={buttonVariants.CONTAINED} onClick={onCreateProject}>
          Create Project
        </Button>
      }
    />
  );
};

export default EmptyProjectsState;
